import { render } from "./FirebaseUserManager.vue?vue&type=template&id=28b2fdef&scoped=true"
import script from "./FirebaseUserManager.vue?vue&type=script&lang=js"
export * from "./FirebaseUserManager.vue?vue&type=script&lang=js"

import "./FirebaseUserManager.vue?vue&type=style&index=0&id=28b2fdef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b2fdef"]])

export default __exports__